

import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
} from './types';
import {
    LinkIncidents
} from './linkincidents';


/**
 * Redux action creator to set the list
 * of Link Incidents
 * @param linkincidentstate list of Linked Incident info
 * @returns action instance
 */
export const setAction = (linkincidentstate: LinkIncidents):
    Action<typeof SET, LinkIncidents> => ({
        type: SET,
        payload: linkincidentstate,
    });
/**
 * Re-initialize the state
 * @returns action instance
 */
export const resetAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof resetAction>;
